<i18n
  src="@/locales/views/agro_exporter/quality_control/container/new_inspection.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      name="ae_quality_control_container_list_quality_inspects_path"
      :params="{
        container_id: container_id,
        agro_exporter_process_id: agro_exporter_process_id,
        current_tab: current_tab,
      }"
    />

    <bread-crumbs
      :labels="[
        module_name,
        agro_exporter_process.name,
        container.container_code,
        template?.name,
      ]"
    ></bread-crumbs>
    <template v-if="load_general_data">
      <container-info :container="container" />
      <div class="mt-8">
        <div class="panel">
          <div class="panel-header">
            <h3 class="panel-header-title">
              {{ $t("labels.title") }}
            </h3>
          </div>

          <div class="panel-body">
            <div
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 w-full pb-6"
            >
              <div class="sm:col-span-3">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.registered_at") }}
                </label>
                <div class="mt-1 relative rounded-md shadow-sm z-10">
                  <date-form
                    v-if="render_registered_at"
                    v-model="registered_at"
                    :first-day-of-week="2"
                    locale="es"
                    show-iso-weeknumbers
                  ></date-form>
                </div>
              </div>
              <div class="sm:col-span-3" v-if="template?.control_exportation">
                <label
                  for="origin_export_id"
                  class="block text-sm font-medium text-gray-700"
                >
                  Productor(a)
                </label>
                <div class="mt-1">
                  <select-form
                    v-if="exported_batch_options.length > 1"
                    v-model="exported_batch_id"
                    :options="exported_batch_options"
                  />
                  <div
                    class="content-data"
                    v-else-if="exported_batch_options.length == 1"
                  >
                    {{ exported_batch_options[0]?.name }}
                  </div>
                </div>
              </div>
              <div
                class="sm:col-span-3"
                v-if="
                  template &&
                  template?.use_samplings &&
                  !template?.specific_sampling
                "
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.samplings") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.lazy.number="samplings"
                    class="input-text"
                  />
                </div>
              </div>
              <div class="sm:col-span-6">
                <label class="label-form">
                  {{ $t("model.quality_inspect.observations") }}
                </label>
                <div class="mt-1">
                  <textarea
                    v-model="observations"
                    rows="3"
                    class="input-text-area"
                  />
                </div>
              </div>
            </div>
            <template v-if="template">
              <sampling-layout
                v-if="template.use_samplings"
                v-model="quality_samplings"
                :samplings="samplings"
                :quality_template="template"
              />
              <general-layout
                v-else
                v-model="quality_generals"
                :quality_template="template"
              />
            </template>
          </div>
          <div class="panel-footer">
            <div class="panel-footer-actions">
              <white-button
                @click.prevent="gotToContainer()"
                :label="$t('labels.cancel_button')"
              />
              <span class="space-actions"></span>
              <success-button
                v-if="!proc_save_button"
                @click.prevent="submit()"
                :label="$t('labels.save_button')"
              />
              <success-button-processing
                v-else
                :label="$t('labels.save_button')"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/container/new_inspection.js";
import ContainerInfo from "@/components/views/agro_exporter/quality_control/container/ContainerInfo.vue";
import GoBackLink from "@/components/views/layout/GoBackLink";
import SamplingLayout from "@/components/views/layout/quality_control/SamplingLayout.vue";
import GeneralLayout from "@/components/views/layout/quality_control/GeneralLayout.vue";

import moment from "moment";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: {
    ContainerInfo,
    GoBackLink,
    BreadCrumbs,
    SamplingLayout,
    GeneralLayout,
  },
  props: {
    agro_exporter_id: { required: true },
    container_id: {
      required: true,
    },
    quality_template_id: {
      required: true,
    },
    exporter_process_quality_template_id: {
      required: true,
    },
    agro_exporter_process_id: {
      required: true,
    },
    current_tab: {},
  },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      render_registered_at: false,
      agro_exporter_process: {},
      container: {},
      template: null,
      samplings: null,
      registered_at: null,
      observations: null,
      exported_batch: null,
      exported_batch_id: null,
      exported_batches: [],
      exported_batch_options: [],
      quality_generals: [],
      quality_samplings: [],
    };
  },
  computed: {
    can_send: function () {
      return this.valid_data && !this.proc_save_button && this.template;
    },
    registered_at_formatted: function () {
      return moment(this.registered_at).format("YYYY-MM-DD");
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
    valid_data: function () {
      return (
        Boolean(this.registered_at) &&
        (Boolean(this.samplings) || !this.template?.use_samplings) &&
        Boolean(this.exported_batch_id)
      );
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.registered_at = moment().format("YYYY-MM-DD");
        this.render_registered_at = true;
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchTemplate().then(() => {
        if (this.template?.control_exportation) this.fetchExportedBatches();
      });
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    exportedBatchOption: function (exported_batch) {
      let label = "";
      if (exported_batch.producer) {
        label += exported_batch.producer;
        if (exported_batch.organization)
          label += ` (${exported_batch.organization})`;
      } else label += exported_batch.organization;
      return {
        name: label,
        id: exported_batch.id,
      };
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.agro_exporter_process_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchExportedBatches: async function () {
      let response = await Requester.fetchExportedBatches({
        container_id: this.container_id,
      });
      this.exported_batches = response.data;
      this.exported_batches.forEach((exported_batch) => {
        this.exported_batch_options.push(
          this.exportedBatchOption(exported_batch)
        );
      });
      if (this.exported_batches.length == 1)
        this.exported_batch_id = this.exported_batches[0]?.id;
    },
    fetchTemplate: async function () {
      let response = await Requester.fetchTemplate({
        quality_template_id: this.quality_template_id,
        container_id: this.container_id,
      });
      this.template = response.data;
      if (this.template?.specific_sampling)
        this.samplings = this.template?.samplings;
    },
    gotToContainer: function () {
      this.$router.push({
        name: "ae_quality_control_container_list_quality_inspects_path",
        params: {
          container_id: this.container_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id,
        },
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.proc_save_button = true;
      if (this.template?.use_samplings) await this.submit_with_samplings();
      else await this.submit_without_samplings();
      this.proc_save_button = false;
    },
    submit_with_samplings: async function () {
      try {
        let response = await Requester.createWithSamplings({
          container_id: this.container_id,
          quality_template_id: this.quality_template_id,
          registered_at: this.registered_at_formatted,
          exported_batch_id: this.exported_batch_id,
          samplings: this.samplings,
          observations: this.observations,
          quality_samplings: this.quality_samplings,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.gotToContainer();
      } catch (error) {
        console.log(error);
      }
    },
    submit_without_samplings: async function () {
      try {
        let response = await Requester.createWithoutSamplings({
          container_id: this.container_id,
          quality_template_id: this.quality_template_id,
          registered_at: this.registered_at_formatted,
          exported_batch_id: this.exported_batch_id,
          observations: this.observations,
          quality_generals: this.quality_generals,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.gotToContainer();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
